import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  if (!lenis) {
    lenis = new Lenis({ autoRaf: true, lerp: 0.09, wheelMultiplier: 1 });
  }
  return lenis;
}

export function getLenis() {
  return lenis;
}
